import './style.sass';

import React from 'react';

import withSizes from 'react-sizes';

import { ExplanationAttributesDesktop } from './ExplanationAttributesDesktop';
import { ExplanationAttributesMobile } from './ExplanationAttributesMobile';

const mapSizesToProps = ({ width }) => ({
  winW: width
})

class ExplanationAttributes extends React.Component {
  constructor(props) {
    super(props)
    this.callbackUpdatedAttributes = this.callbackUpdatedAttributes.bind(this);
  }

  callbackUpdatedAttributes({ attributes } = {}) {
    const cb = this.props.callbackUpdatedAttributes
    cb && cb({ attributes })
  }

  render() {
    // Saturation prop 'isActive' and remove '2D'
    const attrs = this.props.uniqueAttributes
      // .map(_ => ({ ..._, isActive: false }))
      .filter(_ => '2D' !== _.short_name.toLocaleUpperCase())

    if (attrs.length === 0) {
      return null
    }

    if (this.props.winW < 981) {
      return (
        <div className={this.props.cssMobileClassForPage}>
          <div className='tech mobile'>
            <ExplanationAttributesMobile attributes={attrs} callbackUpdatedAttributes={this.callbackUpdatedAttributes} />
          </div>
        </div>
      )
    }

    return (
      <div className={this.props.cssDesktopClassForPage}>
        <div className='tech desktop'>
          <ExplanationAttributesDesktop attributes={attrs} callbackUpdatedAttributes={this.callbackUpdatedAttributes} />
        </div>
      </div>
    )
  }
}

export default withSizes(mapSizesToProps)(ExplanationAttributes)




// WEBPACK FOOTER //
// ./src/components/snippets/ExplanationAttributes/ExplanationAttributes.jsx